import { Button } from '@pms-digital/design-system';
import { CadreAnalyse } from './cadre-analyse';

interface TraductionIntrouvableProps {
  /** "nouveau texte": empties the draft and goes back to the input screen. */
  onNouveauTexte: () => void;
}

/**
 * Page shown when the identifier of the URL is not a translation (no mockup): the same form as
 * the one of the result (B10, #13).
 */
export function TraductionIntrouvable({ onNouveauTexte }: TraductionIntrouvableProps) {
  return (
    <CadreAnalyse titre="Traduction introuvable">
      <div className="flex flex-col items-start gap-6">
        <h1 className="font-light text-h2 leading-[1.2]">Cette traduction est introuvable.</h1>
        <Button type="button" variant="secondary" icon="add" onClick={onNouveauTexte}>
          nouveau texte
        </Button>
      </div>
    </CadreAnalyse>
  );
}
